import { Theme, useTheme } from '@mui/material/styles';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { ScoringContext } from '@/contexts/scoring/context';
import { ARIA_LABEL } from '@/constants/ariaLabel';
import { COLLECTION_RANK_IDS } from '@/service/constants';
import { ROUTE_PATHS } from '@/router/constants';
import { NavBarBadge } from '../common/NavBarBadge';

export const RankInfo = () => {
  const theme = useTheme<Theme>();
  const { pathname } = useLocation();
  const {
    state: { fixtureSummary },
  } = useContext(ScoringContext);

  if (
    !fixtureSummary?.rank ||
    pathname === ROUTE_PATHS.SUPER_ADMIN ||
    pathname === ROUTE_PATHS.HOME
  ) {
    return null;
  }

  return (
    <NavBarBadge
      ariaLabel={ARIA_LABEL.RANK_INFO}
      label={fixtureSummary.rank.displayValue}
      sxProps={{
        textTransform: 'capitalize',
        background: theme.palette.rank[fixtureSummary.rank.value],
        color:
          fixtureSummary.rank.value === COLLECTION_RANK_IDS.SILVER
            ? theme.palette.common.black
            : theme.palette.common.white,
      }}
    />
  );
};
